import { useState } from "react";
import Joi from "joi-browser"

const useForm = (schema, doSubmit) => {
    
    const [stateData, setStateData] = useState({});
    const [stateErrors,setStateErrors]=useState({});

    const handleChange = ({ currentTarget: input }) => {
        const data = { ...stateData, [input.name]: input.value };
        const errors = { ...stateErrors };
        const errorMessage = validateProperty(input, data);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];

        // If newPassword changed and confirmPassword exists, revalidate confirmPassword
        if (input.name === "newPassword" && schema.confirmPassword) {
            if (data.confirmPassword !== undefined && data.confirmPassword !== "") {
                const confirmError = validateProperty({ name: "confirmPassword", value: data.confirmPassword }, data);
                if (confirmError) errors.confirmPassword = confirmError;
                else delete errors.confirmPassword;
            }
        }

        setStateData(data);
        setStateErrors(errors);
    };

    const validateProperty = ({ name, value }, currentData = stateData) => {
        if (!schema[name]) return null;
        const obj = { ...currentData, [name]: value };
        const nschema = { [name]: schema[name] };
        const { error } = Joi.validate(obj, nschema, { allowUnknown: true });
        return error ? error.details[0].message : null;
    };

    const validate = () => {
        const options = { abortEarly: false, allowUnknown: true };
        const result = Joi.validate(stateData, schema, options);
        if (!result.error) return null;
        const errors = {};
        for (let item of result.error.details) {
            const reqFlag = schema[item.path[0]]?._flags?.presence;
            if (reqFlag === "required" || (stateData[item.path[0]] !== undefined && stateData[item.path[0]] !== "")) {
                errors[item.path[0]] = item.message;
            }
            //errors[item.path[0]] = item.message;
        }
        if (Object.keys(errors).length > 0) return errors;
        return null;
    };

    const handleSubmit = (btnType) => {
        //e.preventDefault();
        const errors = validate();
        setStateErrors(errors || {});
        if (errors) return;
        doSubmit(btnType);
    };

    return {
        stateData,
        setStateData,
        setStateErrors,
        stateErrors,
        handleChange,
        validate,
        handleSubmit,
    }

}

export default useForm;